import { InfoCircle } from '@untitled-ui/icons-react';
import React from 'react';

import { Callout } from '@myhealth-raccoon/components';

import { AppointmentType } from 'src/services/availability';
import { isExpressTelehealth } from 'src/utils/appointmentTypes.ts';
import { innerHtml } from 'src/utils/html.ts';

type Props = {
    html: string;
    appointmentType?: AppointmentType;
    className?: string;
};

export function CancellationPolicyNotice({ html, appointmentType, className }: Props) {
    if (!appointmentType) {
        return html;
    }
    const nonCancellableBookingTypes = ['RECALL', 'RESULT', 'EXPRESS'];

    const bpNameUpper = appointmentType.appointmentBPName.toUpperCase();
    const canAppointmentBeCancelled = !nonCancellableBookingTypes.some((type) => bpNameUpper.includes(type));

    return (
        <div className={className}>
            <Callout role="alert" Icon={InfoCircle} color="info">
                {canAppointmentBeCancelled ? (
                    <>
                        <strong className="font-semibold">{appointmentType.appointmentName}</strong> requires at least{' '}
                        <strong className="font-bold">{appointmentType.cancellationPeriodInPriorHrs} hours</strong>{' '}
                        prior to the appointment of notice for cancellations or rescheduling.
                    </>
                ) : (
                    <>
                        <strong className="font-semibold">{appointmentType.appointmentName}</strong> cannot be cancelled
                        online, contact the clinic for any changes.
                    </>
                )}
            </Callout>
            {!isExpressTelehealth(appointmentType) && html && (
                <div className="prose prose-sm mt-4" {...innerHtml(html)} />
            )}
        </div>
    );
}
